import { OnInit, Component, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { CardModel } from '../../../../../../shared/models/payment/card.model';
import { AccountSubscriptionsDetailsActionsPaymentMethod } from '../account.subscriptions.details.actions.payment-method';
import { Response } from '@angular/http';
import { CommonHttpService } from '../../../../../../shared/services/http.service';
import { InstallmentModel } from '../../../../../../shared/models/installment.model';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'account-subscriptions-details-actions-payment-method-card',
    templateUrl: './account.subscriptions.details.actions.payment-method.card.component.html',
    styleUrls: ['./../../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsPaymentMethodCardComponent extends
    AccountSubscriptionsDetailsActionsPaymentMethod implements OnInit {
    @Output('canceled') canceled: EventEmitter<null> = new EventEmitter<null>();

    public cards: Array<CardModel> = [];
    public installments: Array<InstallmentModel> = [];
    public hasMoreCardsToLoad = false;
    public loadingCards = false;
    public loadingInstallments = false;
    public currentCardsOffset = 0;
    public data = {payment_card_id: null, installments: null};
    protected currencyPipe = new CurrencyPipe('pt-BR');

    constructor(
        protected http: CommonHttpService
    ) {
        super();
    }

    ngOnInit() {
        this.loadCards();
        this.loadInstallments();
    }

    /**
     * Load cards from logged user account.
     **/
    protected loadCards() {
        this.loadingCards = true;
        this.http
            .useAuth()
            .get(
                '/account/clients/'
                + this.client.id
                + '/cards?_sort=-id&_limit=5&_offset='
                + this.currentCardsOffset
                + '&_config=meta-has-more-pages&payment_method_id='
                + this.paymentMethod.id
            )
            .subscribe((response: Response) => {
                this.loadingCards = false;
                this.cards = this.cards.concat(response.json().data);
                this.hasMoreCardsToLoad = response.json().meta['meta-has-more-pages'];
                this.currentCardsOffset = this.cards.length;
            }, () => {
                this.loadingCards = false;
            });
    }
    /**
     * Load installments rules for payment method.
     **/
    protected loadInstallments() {
        this.loadingInstallments = true;
        this.http
            .useAuth()
            .get(
                '/account/clients/'
                + this.client.id
                + '/subscriptions/'
                + this.subscription.id
                + '/payment-methods/'
                + this.paymentMethod.id
                + '/installments'
            )
            .subscribe((response: Response) => {
                this.loadingInstallments = false;
                this.installments = response.json().data;

                if (this.installments.length >= 1) {
                    this.data.installments = this.installments[0].number;
                    this.checkFill();
                }
            }, () => {
                this.loadingInstallments = false;
            });
    }
    /**
     * Build installment translation object returning parameters for
     * translation string.
     **/
    public buildInstallmentTranslation(installment: InstallmentModel): any {
        const params = {
            'installmentNumber': installment.number,
            'formattedInstallmentAmount': this.toCurrency(installment.amount)
        };
        if (installment.interest > 0) {
            params['formattedInstallmentInterestAmount'] = this.toCurrency(installment.interest_amount)
        }

        return params;
    }
    /**
     * Notify cancel.
     **/
    public cancel() {
        this.canceled.emit();
    }
    /**
     * Check if all data was filled and notify as chosen.
     **/
    public checkFill() {
        if (this.data.payment_card_id !== null && this.data.installments !== null) {
            this.choose(
                this.paymentMethod.id,
                this.data.installments,
                this.data.payment_card_id
            );
        }
    }
    /**
     * Format to BRL currency using CurrencyPipe.
     **/
    private toCurrency(value: number) {
        return this.currencyPipe.transform(
            value,
            'BRL',
            true,
            '1.2-2'
        );
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/subscriptions/details/actions/payment-method/card/account.subscriptions.details.actions.payment-method.card.component.ts